import Vue from 'vue';
import Vuex from 'vuex';
import config from './modules/config'; 
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    user: null,  // This could hold your user object or any global state
    isAuthenticated: false  // Flag to check if the user is authenticated
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      state.isAuthenticated = !!user;
    },
    clearUser(state) {
      state.user = null;
      state.isAuthenticated = false;
    }
  },
  actions: {
    login({ commit }, user) {
      // Perform login logic, then commit the user to the state
      commit('setUser', user);
    },
    logout({ commit }) {
      // Perform logout logic, then clear the user from the state
      commit('clearUser');
    }
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    getUser: state => state.user
  },
  modules: {
    config
  }
});

export default store;
